var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffAssign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.02,
    height: 15.02,
    viewBox: "0 0 15.02 15.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15814 -12731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.715,205a.715.715,0,1,1-.506.21A.715.715,0,0,1,305.715,205Zm2.146,0a.715.715,0,1,1-.506.21A.715.715,0,0,1,307.861,205Z",
    transform: "translate(-16116.854 12528.146)",
    fill: "#0d3b66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.073,202.715a.358.358,0,0,0-.358.358v11.443A1.788,1.788,0,0,0,304.5,216.3h10.013a1.788,1.788,0,0,0,1.788-1.788V203.073a.358.358,0,0,0-.358-.358Zm0-.715h12.874a1.073,1.073,0,0,1,1.073,1.073v11.443a2.5,2.5,0,0,1-2.5,2.5H304.5a2.5,2.5,0,0,1-2.5-2.5V203.073A1.073,1.073,0,0,1,303.073,202Z",
    transform: "translate(-16116 12529)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,208.715V208h15.02v.715Z",
    transform: "translate(-16116 12527.292)",
    fill: "#0d3b66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,213.113a.358.358,0,0,1,.509.5l-2.826,2.861a.358.358,0,0,1-.5,0l-1.465-1.436a.358.358,0,0,1,.5-.511l1.211,1.188Z",
    transform: "translate(-16117.994 12525.86)",
    fill: "#0d3b66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffAssign);
export default __webpack_public_path__ + "static/media/staff_assign.c338ef78b653691b31dc7e1ddc1a9b0f.svg";
export { ForwardRef as ReactComponent };